<template>
  <b-card-actions>
    <div class="row">
      <div class="col-6 mb-5 mb-xl-2 col-xl-3 statistics-item">
        <div class="notifi-card baby-blue">
          <i class="far fa-clock"></i>
          <div class="title">
            <p>ساعات الدراسة</p>
            <h2 v-if="eduProgram" class="text-center">
              {{ eduProgram.program_list.num_of_study_hours }}
            </h2>
            <b-spinner v-else type="grow" label="Loading..."  class="loading" />
          </div>
        </div>
      </div>
      <div class="col-6 mb-5 mb-xl-2 col-xl-3 statistics-item">
        <div class="notifi-card border-success">
          <i class="far fa-file"></i>
          <div class="title">
            <p>اختبارات اجتيزت</p>

            <h2 v-if="data" class="text-center">
              {{ data.exams ? data.exams : 0 }}
            </h2>
            <b-spinner v-else type="grow" label="Loading..."  class="loading" />
          </div>
        </div>
      </div>
      <div class="col-6 col-xl-3 statistics-item">
        <div class="notifi-card border-warning">
          <i class="fas fa-chalkboard-teacher"></i>
          <div class="title">
            <p class="text-warning">تدريبات غير مكتملة</p>

            <h2 v-if="data" class="text-center">
              {{ data.knAssessments ? data.knAssessments : 0 }}
            </h2>
            <b-spinner v-else type="grow" label="Loading..."  class="loading" />
          </div>
        </div>
      </div>
      <div class="col-6 col-xl-3 statistics-item">
        <div class="notifi-card border-danger">
          <i class="fas fa-user-clock"></i>
          <div class="title">
            <p>{{$t('online_session.online_class_time')}}</p>

            <h2 v-if="eduProgram" class="text-center">
              {{ eduProgram.program_list.num_of_direct_sessions_hours }}
            </h2>
            <b-spinner v-else type="grow" label="Loading..."  class="loading" />
          </div>
        </div>
      </div>
    </div>
  </b-card-actions>
</template>

<script>
import Auth from "@/Apis/Auth";

import BCardActions from "@core/components/b-card-actions/BCardActions.vue";
export default {
  components: {
    BCardActions,
  },
  props: {
    data: {},
    // eduProgram: {},
  },
  data() {
    return {
      eduProgram: {},
    };
  },
  created() {
    let eduProgramId = localStorage.getItem("eduProgram");
    this.eduProgram = Auth.EDU_PROGRAMS.find((a) => a.id == eduProgramId);
  },
};
</script>

<style>
</style>
